<template>
  <div class="story-popup content-popup">
    <div class="popup-inner" v-if="story">
      <div class="close-button" @click="closePopup">
        <img :src="closeButtonImage">
      </div>
      <VuePerfectScrollbar class="scroll-area">
        <div
          v-if="story.mainImageUrl"
          class="story-thumbnail"
          :style="{ backgroundImage: `url(${story.mainImageUrl})` }"
        ></div>
        <div class="popup-content">
          <h1 class="story-title">{{story.title}}</h1>
          <div class="story-meta">
            <div v-if="authorName" class="story-author">{{authorName}}</div>
            <div v-if="publishDate" class="story-date">{{publishDate}}</div>
          </div>
          <div class="story-share">
            <img @click="share" :src="shareIcon">
          </div>
          <div class="story-content" v-if="story.content" v-html="story.content"></div>
          <div class="story-content" v-else>{{story.description}}</div>
        </div>
      </VuePerfectScrollbar>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import moment from "moment";
import closeButtonImage from "@/assets/img/experiences/close.svg";
import shareIcon from "@/assets/img/share.svg";
export default {
  name: "storyPopup",
  components: {
    VuePerfectScrollbar
  },
  props: {
    story: {
      type: Object,
      required: true
    }
  },
  data() {
    return { closeButtonImage, shareIcon };
  },
  computed: {
    authorName() {
      if (this.story && this.story.author) {
        return (story.author.firstName + " " + story.author.lastName).trim();
      } else {
        return "";
      }
    },
    publishDate() {
      if (this.story && this.story.publishDate) {
        return moment(this.story.publishDate).format("D/M/Y");
      } else {
        return "";
      }
    }
  },
  methods: {
    closePopup() {
      this.$emit("close");
    },
    share() {
      if (navigator.share) {
        navigator
          .share({
            title: this.story.title,
            text: this.story.description,
            url: window.location.href
          })
          .catch(console.error);
      }
    }
  }
};
</script>

<style lang="scss">
.story-popup {
  width: 100vw;
  height: calc(100vh - 52px);
  background-color: #fff;
  position: fixed;
  z-index: 1003;
  left: 0;
  top: 52px;
  right: 0;
  bottom: 0;
  overflow: hidden;
  text-align: center;

  .VueCarousel-inner {
    visibility: visible !important;
  }

  .popup-inner {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .close-button {
    position: absolute;
    top: 14px;
    right: 14px;
    z-index: 2;
    width: 40px;
    height: 40px;

    img {
      width: 40px;
      height: 40px;
    }
  }

  .scroll-area {
    width: 100%;
    height: 100%;
  }

  .popup-content {
    padding: 1rem;
  }

  .story-thumbnail {
    width: 100vw;
    height: 0;
    padding-bottom: 80vw;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }

  .story-title {
    font-size: 1rem;
    margin: 0 auto 1rem;
    font-weight: bold;
  }

  .story-meta {
    font-size: 0.9rem;
    margin: 1rem auto;
  }

  .story-share {
    margin: 1rem auto 1.5rem;
  }

  .story-content {
    font-size: 0.75rem;

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      font-size: 0.75rem;
      font-weight: bold;
    }
  }
}
</style>
